import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { s3baseUrl } from "src/config/config";
import { gr } from "src/design-system/tokens";
import GrCard from "src/design-system/components/GrCard";
import GrAvatar from "src/design-system/components/GrAvatar";
import { grCleanName } from "src/design-system/components/GrChatListRow";

// Prompt text (approved by Mohsin to try, TASK-019); the plain one when the member has no first name.
const promptText = (firstName) =>
  firstName ? `What's on your mind, ${firstName}?` : "What's on your mind ?";

const rowSx = { display: "flex", alignItems: "center", gap: gr.space[3] };
// Looks like an input, works as a button: opens the Create Post popup (photo / video are chosen there).
const fakeInputSx = {
  flex: 1,
  minWidth: 0,
  minHeight: gr.control.touch,
  px: gr.space[4],
  border: 0,
  borderRadius: gr.radius.pill,
  background: gr.color.tint,
  color: gr.color.muted,
  fontFamily: gr.font.family,
  fontSize: gr.font.size.md,
  textAlign: "left",
  cursor: "pointer",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  transition: "background-color .15s ease",
  "&:hover": { background: gr.color.brandSoft },
  "&:focus-visible": { outline: "none", boxShadow: gr.shadow.focus },
};

function OpenCreatePostCard({ handleOpenSimpleBox, userInfo }) {
  const firstName = grCleanName(userInfo?.first_name);
  const fullName = grCleanName(
    `${userInfo?.first_name || ""} ${userInfo?.last_name || ""}`
  );

  return (
    <GrCard padding="sm">
      <Box sx={rowSx}>
        <GrAvatar src={s3baseUrl + userInfo?.profile_image} name={fullName} />
        <Box
          component="button"
          type="button"
          sx={fakeInputSx}
          onClick={handleOpenSimpleBox}
        >
          {promptText(firstName)}
        </Box>
      </Box>
    </GrCard>
  );
}

OpenCreatePostCard.propTypes = {
  handleOpenSimpleBox: PropTypes.func.isRequired,
  userInfo: PropTypes.object,
};

export default OpenCreatePostCard;
